import Axios from 'axios'
import flinks from '@/mixins/flinks'

export default {
  // Mixins
  mixins: [flinks],

  // Data
  data () {
    return {
      submitUrl: `${process.env.VUE_APP_LEAD_API_URL}/${process.env.VUE_APP_SUBMIT_URL || 'lead'}`,
      submitError: undefined,
      resubmitUrl: process.env.VUE_APP_RESUBMIT_URL,
      resubmitError: undefined,
      slackServiceUrl: process.env.VUE_APP_SLACK_SERVICE_URL,
      slackChannel: process.env.VUE_APP_SLACK_CHANNEL,
      submitting: false,
      showSubmitPopup: false
    }
  },

  // Computed
  computed: {
    application () {
      return this.$store.state.application
    },

    submittedApp () {
      return this.application.submitted_app
    },

    submittedThanks () {
      return this.application.submitted_thanks
    },

    submittedDocuments () {
      return this.application.submitted_documents
    },

    submittedBanking () {
      return this.application.submitted_banking
    },

    submittedToSF () {
      return this.application.submitted_to_sf
    },

    uid () {
      return this.application.uid || this.$route.query.cduid
    },

    instantLeadSubmissionUrl () {
      return `${process.env.VUE_APP_LEAD_API_URL}/${process.env.VUE_APP_INSTANT_SUBMIT_URL || 'submit'}/${this.uid}`
    },

    submitConfirmationURL () {
      return `${process.env.VUE_APP_LEAD_API_URL}/${process.env.VUE_APP_SUBMIT_URL || 'lead'}/${this.uid || ''}`
    },

    creditScoreUrl () {
      if (!this.uid) return
      return `${process.env.VUE_APP_LEAD_API_URL}/${process.env.VUE_APP_CREDIT_SCORE_URL || 'get-report'}/${this.uid}`
    },

    leadData () {
      // let application = Object.assign({}, this.application)
      let application = { ...this.application }
      let data = new FormData()
      for (let key in application) {
        const value = application[key] !== undefined
          ? application[key]
          : ''
        data.append(key, value)
      }
      return data
    },

    thanksLeadData () {
      const data = {
        'work_phone': this.application.work_phone,
        'monthly_income': this.application.monthly_income_updated,
        // 'monthly_income': this.application.monthly_income,
        'income_detail': this.application.income_detail,
        'select_paid_frequency': this.application.select_paid_frequency,
        'hours_per_week': this.application.hours_per_week,
        'pay_per_hour': this.application.pay_per_hour,
        'pay_per_week': this.application.pay_per_week,
        'pay_per_two_week': this.application.pay_per_two_week,
        'pay_per_half_month': this.application.pay_per_half_month,
        'pay_per_month': this.application.pay_per_month,
        'pay_per_year': this.application.pay_per_year,
        'consent_CEMs': this.application.consent_CEMs,
        'thanks_verified': 1
      }
      return data
    },

    failedLeadData () {
      let data = this.leadData
      data.append('endpoint', this.submitUrl)
      if (this.submitError.request && this.submitError.request.status) {
        data.append('http_code', this.submitError.request.status)
      }
      return data
    },

    slackData () {
      if (this.resubmitError === undefined) return
      let object = {}
      this.leadData.forEach((value, key) => { object[key] = value })
      let json = JSON.stringify(object)
      let data = new FormData()
      data.append('channel', this.slackChannel)
      data.append('file_type', 'javascript')
      data.append('file_name', 'failed_lead')
      data.append('message', json)
      return data
    },

    redirectToDocuments () {
      return this.$store.state.application.show_uploader
    },

    redirectToBanking () {
      return this.$store.state.application.show_flinks
    }
  },

  // Methods
  methods: {
    /**
     * Submit Application
     * Submit the lead to the API, if successful get a redirect token
     */
    async submitApplication () {
      if (this.submitting) return

      this.submitting = true

      if (this.submittedApp) return

      if (this.$route.name === 'Demo') {
        this.redirectToThanks()
        return
      }

      try {
        const response = await Axios({
          method: 'post',
          url: this.submitUrl,
          data: this.leadData
        })
        if (!response.data.success) {
          throw new Error('Failed to submit application')
        }
        this.$store.updateApplication('submitted_app', true)
        this.$store.updateApplication('uid', response.data.data.uid)

        this.$store.updateApplication('show_uploader', response.data.data.show_uploader)
        // TODO: hardcoding 'show_flinks' to false here until we want to enable flinks for ACD
        this.$store.updateApplication('show_flinks', false)

        // If pull_report is true, make the request for the customer's score
        if (response.data.data.pull_report) {
          // const creditScore = await this.getCreditScore()
          // this.$store.updateApplication('credit_score', creditScore)
        }
        // this.redirectToThanks()
      } catch (error) {
        this.submitError = error
        this.resubmitFailedLead()
        this.showSubmitPopup = false
      } finally {
        this.submitting = false
      }
    },

    async resubmitFailedLead () {
      try {
        await Axios({
          method: 'post',
          url: this.resubmitUrl,
          data: this.failedLeadData
        })

        this.$store.updateApplication('submitted_app', true)
        this.redirectToThanks()
      } catch (error) {
        this.resubmitError = 'Oops! Something went wrong. Please try again or call 1-888-865-6402 to finish your application'
        console.warn(error)
        this.slackFailedLead()
      }
    },

    /**
     * Instantly convert the lead in Salesforce
     * @returns {promise}
    */
    async instantLeadSubmission () {
      try {
        await Axios({
          method: 'PATCH',
          url: this.instantLeadSubmissionUrl
        })
        this.$store.updateApplication('submitted_to_sf', true)
      } catch (error) {
        console.warn(error)
      }
    },

    /**
     * Slack Failed Lead
     * Sends the failed lead data to the slack channel
     */
    async slackFailedLead () {
      try {
        await Axios({
          method: 'post',
          url: this.slackServiceUrl,
          data: this.slackData
        })
      } catch (error) {
        console.error('Failed to post to Slack')
      }
    },

    /**
     * Thanks page lead data submission
     * Submits the confirmed email and optional work number
     *
     * @param {string} url
     */
    async submitConfirmationDetails () {
      try {
        const response = await Axios({
          url: this.submitConfirmationURL,
          method: 'patch',
          data: this.thanksLeadData
        })

        this.$store.updateApplication('show_uploader', response.data.data.show_uploader)
        // TODO: hardcoding 'show_flinks' to false here until we want to enable flinks for ACD
        this.$store.updateApplication('show_flinks', false)
        this.$store.updateApplication('submitted_thanks', true)
      } catch (error) {
        console.warn(error)
        return this.$router.replace({
          path: '/finished',
          query: { ...this.$route.query }
        })
      }
    },

    /**
     * Post-Thanks Redirect
     * Redirects the user to either the /finished or /documents route.
     * The Lead API determines which route we should redirect the user to.
     * @param {Boolean} redirectToDocuments
     */
    async postThanksRedirect (variation = '') {
      try {
        let nextPath = `/finished/${variation}`
        if (this.redirectToBanking && this.$_flinks_isEnabled) nextPath = `/banking/${variation}`
        if (this.redirectToDocuments) nextPath = `/documents/${variation}`

        if (nextPath.includes('finished')) {
          await this.instantLeadSubmission()

          return this.$router.replace({
            path: '/finished',
            query: { ...this.$route.query, cduid: this.uid }
          })
        }

        this.$router.push({
          path: nextPath,
          query: { ...this.$route.query, cduid: this.uid }
        })
      } catch (error) {
        console.warn(error)
      }
    },

    /**
     * Redirect the user to the /thanks page
     * Keep any existing query params and add the uid as 'cduid'
     */
    redirectToThanks (variation = '') {
      // if there is a resubmit error, prevent navigation
      if (this.resubmitError) return

      const query = {
        ...this.$route.query,
        cduid: this.uid
      }

      if (this.$route.name === 'Cosigner') {
        query['cosigner'] = null
      }

      this.$router.push({
        path: `/thanks/${variation}`,
        query
      })
    },

    redirectToFinished () {
      this.$router.replace({
        path: '/finished',
        query: { ...this.$route.query }
      })
    },

    /**
     * Get Credit Score
     * After we receive the UID from Lead API,
     * make a request to get the users credit score
     */
    async getCreditScore () {
      try {
        const response = await Axios({
          method: 'post',
          url: this.creditScoreUrl
        })
        return response.data.score
      } catch (error) {
        console.warn(error)
      }
    }
  }
}
